export class PathUtils {
    constructor() {}

    /**
     * Joins arguments to a path
     * joinPath("http://google.com/", "my", "path") will return "http://google.com/my/path"
     * joinPath("//a", "", "/", "/b/") will return "//a/b"
     * joinPath() will return ""
     *
     * @param args
     */
    static joinPath(...args: any[]): string {
        return args.map((part, i) => {
            if (i === 0) {
                return part.trim().replace(/[\/]*$/g, "");
            } else {
                return part.trim().replace(/(^[\/]*|[\/]*$)/g, "");
            }
        }).filter((x) => x.length).join("/");
    }

    static getMetaId( path: string): string {
        path = path.replace(/\/(FeatureServer|MapServer|ImageServer)(|\/|\/(\d+))$/i, "");
        path = path.replace(/\/VectorTileServer\/(.+)\.json$/i, "");
        path = path.substring(path.lastIndexOf("/") + 1);
        path = path.replace(/_map$/i, "");
        path = path.replace(/_v(\d+)(_FT|_MP|_IM|_VT|$)/i, ""); // Version und Feature/Map Services Postfix entfernen
        return path;
    }
    static getLayerId( path: string): number | null {
        let layerId = null;
        const matches = path.match(/\/(FeatureServer|MapServer|ImageServer)(|\/|\/(\d+))$/i);
        path = path.replace(/\/VectorTileServer\/(.+)\.json$/i, "");
        if(matches && matches.length === 4 && typeof matches[3] !== "undefined"){
            layerId = parseInt(matches[3], 10);
        }
        return layerId;
    }
    static getVersion( path: string): number | null {
        let version = null;
        const matches = path.match(/_v(\d+)(_FT|_MP|_IM|_VT|$)/i);
        if(matches && matches.length === 3 && typeof matches[1] !== "undefined"){
            version = parseInt(matches[1], 10);
        }
        return version;
    }
    static readableUrl(url: string): string {
        const addr = new URL(url);
        url = addr.hostname;
        url = url.replace(/^www\./i, "");
        if (addr.pathname !== "/" || addr.search !=="" || addr.hash !==""){
            url += addr.pathname + addr.search + addr.hash;
        }
        return url;
    }
    // https://stackoverflow.com/questions/1053902/how-to-convert-a-title-to-a-url-slug-in-jquery
    static slug(str: string): string {
        str = str.replace(/^\s+|\s+$/g, ""); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        const from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆĞÍÌÎÏİŇÑÓÖÒÔÕØŘŔŠŞŤÚŮÜÙÛÝŸŽ"
            + "áäâàãåčçćďéěëèêẽĕȇğíìîïıňñóöòôõøðřŕšşťúůüùûýÿžþÞĐđßÆa·/_,:;";
        const to   = "AAAAAACCCDEEEEEEEEGIIIIINNOOOOOORRSSTUUUUUYYZ"
            + "aaaaaacccdeeeeeeeegiiiiinnooooooorrsstuuuuuyyzbBDdBAa------";
        for (let i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
        }
        str = str.replace(/[^a-z0-9 -]/g, "") // remove invalid chars
            .replace(/\s+/g, "-") // collapse whitespace and replace by -
            .replace(/-+/g, "-"); // collapse dashes

        return str;
    };
}

